<template>
  <a-modal
    class="company-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    title="关联推广员"
    @ok="$emit('onCancel')"
    @cancel="$emit('onCancel')"
  >
    <a-table
      :columns="columns"
      :data-source="data"
      size="middle"
      :row-key="record => record.id"
      :pagination="false"
    />
  </a-modal>
</template>
<script>
export default {
  props: ['data', 'visible'],
  data() {
    return {
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
        },
        {
          title: '推广员姓名',
          dataIndex: 'user_realname',
        },
      ],
    };
  },
  mounted() {},
  methods: {
  },
};
</script>
<style lang="scss" scoped>

</style>